module.exports = __webpack_public_path__ + "static/media/total-minutes-icon.1cf5898f.svg";